var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('iframe',{attrs:{"frameborder":"0","marginheight":"0","marginwidth":"0","width":"100%","height":_vm.windowHeight,"src":"http://story.kingpower.com/th/category/promotion-th/"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }